import { render, staticRenderFns } from "./PromotionUsage.vue?vue&type=template&id=763276f0&scoped=true"
import script from "./PromotionUsage.vue?vue&type=script&lang=js"
export * from "./PromotionUsage.vue?vue&type=script&lang=js"
import style0 from "./PromotionUsage.vue?vue&type=style&index=0&id=763276f0&prod&lang=scss&scoped=true"
import style1 from "./PromotionUsage.vue?vue&type=style&index=1&id=763276f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763276f0",
  null
  
)

export default component.exports